//
import * as React from "react";

const ArrowDownBlue: React.FC = () => {
    return (
        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.9184 1.91953L6.45002 6.41953C6.20041 6.64102 5.91213 6.75 5.62385 6.75C5.33557 6.75 5.04799 6.64014 4.82827 6.42041L0.359907 1.92041C0.00674126 1.59961 -0.0896009 1.11445 0.0845631 0.696094C0.258727 0.277734 0.669282 0 1.12385 0H10.0922C10.5471 0 10.9578 0.273551 11.1321 0.694336C11.3065 1.11512 11.2418 1.59961 10.9184 1.91953Z" fill="#0F96D9" />
        </svg>
    );
};

export default React.memo(ArrowDownBlue);
